import React from "react";
import {
  Box,
  Container,
  Flex,
  SimpleGrid,
  Image,
  Text,
  Heading,
  HStack,
  useColorModeValue,
  Divider,
  Tag
} from "@chakra-ui/react";
import { useSelector } from "react-redux";

/**
 * Same DATA, upgraded UI.
 * - No content changes.
 * - Modern research-portal look.
 * - Mobile-first layout.
 * - No cropping: objectFit="contain".
 */

function AvatarCircle({ src, alt, sizePx = 220 }) {
  const ring = useColorModeValue(
    "rgba(2,6,23,0.10)",
    "rgba(148,163,184,0.22)"
  );
  const bg = useColorModeValue(
    "rgba(255,255,255,0.85)",
    "rgba(255,255,255,0.04)"
  );
  const shadow = useColorModeValue(
    "0 14px 34px rgba(0,0,0,0.10)",
    "none"
  );

  return (
    <Box
      boxSize={`${sizePx}px`}
      borderRadius="full"
      overflow="hidden"
      border="1px solid"
      borderColor={ring}
      bg={bg}
      boxShadow={shadow}
      mx="auto"
      flexShrink={0}
    >
      <Image
        src={src}
        alt={alt}
        w="100%"
        h="100%"
        objectFit="cover"
        objectPosition="center"
        draggable={false}
      />
    </Box>
  );
}

const TEAM_DATA = [
  {
    sectionId: "create_traversal_team",
    title: "CREATE TRAVERSAL TEAM",
    type: "people",
    items: [
      {
        name: "Burak Kantarci",
        imageSrc: "BurakNewProfile.jpeg",
        alt: "Burak Kantarci",
        affiliation: { mobile: "Program Director", desktop: "Program Director" },
      },
    ],
  },
  {
    sectionId: "co_investigators",
    title: "CO-INVESTIGATORS",
    type: "people",
    items: [
      { name: "Octavia Dobre", imageSrc: "OctaviaDobre.jpg", alt: "Octavia Dobre", affiliation: { mobile: "Memorial University", desktop: "Memorial University" } },
      { name: "Melike Erol-Kantarci", imageSrc: "MelikeKantarci.jpg", alt: "Melike Erol-Kantarci", affiliation: { mobile: "University of Ottawa", desktop: "University of Ottawa" } },
      { name: "Birsen Donmez", imageSrc: "BirsenDonmez.jpg", alt: "Birsen Donmez", affiliation: { mobile: "University of Toronto", desktop: "University of Toronto" } },
      { name: "Froduald Kabanza", imageSrc: "FrodualdKabanza.jpg", alt: "Froduald Kabanza", affiliation: { mobile: "University de Sherbrooke", desktop: "University de Sherbrooke" } },
      { name: "Lionel Briand", imageSrc: "LionelBriand.jpg", alt: "Lionel Briand", affiliation: { mobile: "University of Ottawa", desktop: "University of Ottawa" } },
      { name: "Robert Laganière", imageSrc: "RobertLaganiere.jpg", alt: "Robert Laganière", affiliation: { mobile: "University of Ottawa", desktop: "University of Ottawa" } },
      { name: "Ebrahim Karimi", imageSrc: "EbrahimKarimi.jpg", alt: "Ebrahim Karimi", affiliation: { mobile: "University of Ottawa", desktop: "University of Ottawa" } },
      { name: "Morad Benyoucef", imageSrc: "MoradBenyoucef.jpeg", alt: "Morad Benyoucef", affiliation: { mobile: "University of Ottawa", desktop: "University of Ottawa" } },
      { name: "Elizabeth Judge", imageSrc: "ElizabethJudge.jpg", alt: "Elizabeth Judge", affiliation: { mobile: "University of Ottawa", desktop: "University of Ottawa" } },
      { name: "Sandra Schillo", imageSrc: "Sandra.png", alt: "Sandra Schillo", affiliation: { mobile: "University of Ottawa", desktop: "University of Ottawa" } },
    ],
  },
  {
    sectionId: "program_committee",
    title: "PROGRAM COMMITTEE",
    type: "people",
    items: [
      { name: "Dana Borschewski", imageSrc: "Dana.png", alt: "Dana Borschewski", affiliation: { mobile: "Head of Partnerships, SureWX", desktop: "Head of Partnerships, SureWX" } },
      {
        name: "Burak Kantarci",
        imageSrc: "BurakNewProfile.jpeg",
        alt: "Burak Kantarci",
        affiliation: { mobile: "Professor, TRAVERSAL Program Director, University of Ottawa", desktop: "Professor, TRAVERSAL Program Director, University of Ottawa" },
      },
      { name: "Hongwen Zhang", imageSrc: "HongwenZhang.jpg", alt: "Hongwen Zhang", affiliation: { mobile: "CEO, Wedge Networks", desktop: "CEO, Wedge Networks" } },
      { name: "Ursula Challita", imageSrc: "UrsulaChallita.jpg", alt: "Ursula Challita", affiliation: { mobile: "AI Strategic Driver-New Businesses, Ericsson", desktop: "AI Strategic Driver-New Businesses, Ericsson" } },
      { name: "Dan Murdock", imageSrc: "DanMurdock.jpeg", alt: "Dan Murdock", affiliation: { mobile: "Director of Engineering and Architecture, Solink", desktop: "Director of Engineering and Architecture, Solink" } },
      { name: "Paul Karam", imageSrc: "paul.jpg", alt: "Paul Karam", affiliation: { mobile: "Chief Operation Officer, Quanser", desktop: "Chief Operation Officer, Quanser" } },
      { name: "Kevin Brynes", imageSrc: "unknown.png", alt: "Kevin Brynes", affiliation: { mobile: "Industry Executive Public Safety and Justice, Microsoft", desktop: "Industry Executive Public Safety and Justice, Microsoft" } },
      {
        name: "Poonam Lohan",
        imageSrc: "poonam.jpg",
        alt: "Poonam Lohan",
        affiliation: { mobile: "Postdoctoral Research Associate SCVIC, University of Ottawa.", desktop: "Postdoctoral Research Associate SCVIC, University of Ottawa." },
      },
    ],
  },
  {
    sectionId: "program_coordinator",
    title: "PROGRAM COORDINATOR",
    type: "people",
    items: [
      { name: "Iraz Eliz Deniz", imageSrc: "eliz.jpg", alt: "Iraz Eliz Deniz", affiliation: { mobile: "(2025- )", desktop: "(2025- )" } },
      { name: "Adeyinka Ogunlami", imageSrc: "Ade.png", alt: "Adeyinka Ogunlami", affiliation: { mobile: "(2023-2024)", desktop: "(2023-2024)" } },
    ],
  },
  {
    sectionId: "collaborators",
    title: "COLLABORATORS",
    type: "people",
    items: [
      { name: "Gerd Leuchs", imageSrc: "GerdLeuchs.jpg", alt: "Gerd Leuchs", affiliation: { mobile: "Max Planck Institute, Germany", desktop: "Max Planck Institute, Germany" } },
      { name: "Gary Burnett", imageSrc: "GaryBurnett.png", alt: "Gary Burnett", affiliation: { mobile: "University of Nottingham", desktop: "University of Nottingham" } },
      { name: "Yacine Ghamri-Doudane", imageSrc: "YacineGhamri.png", alt: "Yacine Ghamri", affiliation: { mobile: "La Rochelle University", desktop: "La Rochelle University" } },
      { name: "Liam Peyton", imageSrc: "Liam.png", alt: "Liam Peyton", affiliation: { mobile: "University of Ottawa", desktop: "University of Ottawa" } },
      { name: "Damla Turgut", imageSrc: "Damla.jpg", alt: "Damla Turgut", affiliation: { mobile: "University of Central Florida", desktop: "University of Central Florida" } },
      { name: "Michele Nogueira", imageSrc: "Michele.png", alt: "Michele Nogueira", affiliation: { mobile: "Federal University of Minas Gerais", desktop: "Federal University of Minas Gerais" } },
    ],
  },
  {
    sectionId: "industry_partners",
    title: "INDUSTRY PARTNERS",
    type: "partners",
    items: [
      { name: "Nokia Bell Labs", imageSrc: "nokia_bell_logo.png", alt: "Nokia Bells" },
      { name: "Ciena", imageSrc: "ciena_logo.jpg", alt: "Ciena Logo" },
      { name: "Quanser", imageSrc: "quanser_logo.jpeg", alt: "Quanser Logo" },
      { name: "Edge Signal", imageSrc: "edge_signal.jpg", alt: "Edge Signal Logo" },
      { name: "Wedge Networks", imageSrc: "wedge-logo.png", alt: "Wedge Logo" },
      { name: "Aurrigo", imageSrc: "aurrigo_logo.png", alt: "Aurrigo Logo" },
      { name: "Irdeto", imageSrc: "irdeto-logo.png", alt: "Irdeto Logo" },
    ],
  },
];


function TraversalTeamHeader() {
  const accent = "#06B6D4";
  const accent2 = "#22D3EE";

  const border = useColorModeValue("rgba(2,6,23,0.10)", "rgba(148,163,184,0.18)");
  const titleColor = useColorModeValue("#0F172A", "white");
  const subColor = useColorModeValue("gray.700", "gray.300");

  const heroBg = useColorModeValue(
    "radial-gradient(1000px 420px at 12% 0%, rgba(6,182,212,0.18), transparent 60%), radial-gradient(900px 380px at 88% 25%, rgba(34,211,238,0.14), transparent 60%), linear-gradient(180deg, rgba(2,6,23,0.02), rgba(2,6,23,0.00))",
    "radial-gradient(1000px 420px at 12% 0%, rgba(6,182,212,0.20), transparent 60%), radial-gradient(900px 380px at 88% 25%, rgba(34,211,238,0.14), transparent 60%), linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.00))"
  );

  return (
    <Box
      pt={{ base: 6, md: 8 }}
      pb={{ base: 8, md: 10 }}
      bg={heroBg}
      borderBottom="1px solid"
      borderColor={border}
    >
      <Container maxW="1200px">
        <HStack spacing={2}>
          <Tag
            size="lg"
            borderRadius="full"
            bg={useColorModeValue("white", "rgba(255,255,255,0.06)")}
            border="1px solid"
            borderColor={border}
            fontWeight="800"
          >
            University of Ottawa
          </Tag>

          <Tag
            size="lg"
            borderRadius="full"
            bg={useColorModeValue("rgba(6,182,212,0.12)", "rgba(6,182,212,0.18)")}
            color={useColorModeValue("#0E7490", "#67E8F9")}
            fontWeight="900"
          >
            TRAVERSAL
          </Tag>
        </HStack>

        <Heading
          mt={4}
          fontSize={{ base: "3xl", md: "4xl" }}
          color={titleColor}
          letterSpacing="tight"
        >
          <Box
            as="span"
            bgClip="text"
            bgGradient={`linear(to-r, ${accent}, ${accent2})`}
          >
            TRAVERSAL
          </Box>{" "}
          Team
        </Heading>

        <Text
          mt={3}
          color={subColor}
          fontSize={{ base: "md", md: "lg" }}
          maxW="85ch"
          lineHeight={1.8}
        >
          Principal Investigators, Co-Investigators, Program Coordination,
          and Industry Partners 
        </Text>
      </Container>
    </Box>
  );
}

export default function Teams() {
  const isMobile = useSelector((state) => state.windowSize.isMobile);

  // spacing from your navbar; keep your existing behavior
  return (
    <Box pb={{ base: 10, md: 14 }}>
      <TraversalTeamHeader />
      {TEAM_DATA.map((section) => (
        <SectionRenderer key={section.sectionId} section={section} isMobile={isMobile} />
      ))}
    </Box>
  );
}

function SectionRenderer({ section, isMobile }) {
  const isPI = section.sectionId === "create_traversal_team";
  const title = isPI ? "PRINCIPAL INVESTIGATOR" : section.title;

  const accent = "#06B6D4";
  const accent2 = "#22D3EE";

  const titleColor = useColorModeValue("#0F172A", "white");
  const subColor = useColorModeValue("gray.600", "gray.300");
  const border = useColorModeValue("rgba(2,6,23,0.10)", "rgba(148,163,184,0.18)");
  const sectionBg = useColorModeValue("white", "#0B1220");
  const bandBg = useColorModeValue("rgba(2,6,23,0.02)", "rgba(255,255,255,0.03)");

  return (
    <Box bg={sectionBg}>
      <Container maxW="1200px" py={{ base: 4, md: 6 }}>
        {/* Header */}
        <StackHeader title={title} titleColor={titleColor} subColor={subColor} />

        {/* Content */}
        {section.type === "people" ? (
          <SimpleGrid
            // PI + program coordinator stay 1 column
            columns={isPI || section.sectionId === "program_coordinator" ? 1 : undefined}

            // For all other people sections: auto-wrap by min width (NO OVERLAP EVER)
            minChildWidth={isPI || section.sectionId === "program_coordinator" ? undefined : "260px"}

            spacing={{ base: 6, md: 8 }}
            mt={{ base: 7, md: 9 }}
            justifyItems="center"
          >
            {section.items.map((p, idx) => (
              <PersonCard
                key={`${section.sectionId}-${idx}`}
                person={p}
                isMobile={isMobile}
                variant={isPI ? "pi" : "default"}
                compact={!(isPI || section.sectionId === "program_coordinator")} // 👈 new
              />
            ))}
          </SimpleGrid>
        ) : (
          <Box
            mt={{ base: 7, md: 9 }}
            border="1px solid"
            borderColor={border}
            borderRadius="26px"
            bg={bandBg}
            p={{ base: 5, md: 7 }}
          >
            <SimpleGrid columns={isMobile ? 2 : 3} spacing={{ base: 6, md: 8 }} alignItems="center">
              {section.items.map((x, idx) => (
                <PartnerLogo key={`${section.sectionId}-${idx}`} partner={x} isMobile={isMobile} />
              ))}
            </SimpleGrid>
          </Box>
        )}

        {/* Section divider */}
        <Box mt={{ base: 5, md: 7 }}>
          <Divider borderColor={border} />
          <Box h="3px" mt={1} bg={`linear-gradient(90deg, ${accent} 0%, ${accent2} 45%, rgba(34,211,238,0) 100%)`} />
        </Box>
      </Container>
    </Box>
  );
}

function StackHeader({ title, titleColor, subColor }) {
  const border = useColorModeValue("rgba(2,6,23,0.10)", "rgba(148,163,184,0.18)");
  return (
    <Box textAlign="center">
      <Heading
        fontSize={{ base: "2xl", md: "3xl" }}
        color={titleColor}
        letterSpacing="tight"
        fontWeight="900"
      >
        {title}
      </Heading>
      <Text mt={2} color={subColor} fontWeight="600">
        {/* no extra content; this keeps it clean */}
      </Text>
      <Box
        mx="auto"
        mt={4}
        w={{ base: "90px", md: "120px" }}
        h="3px"
        borderRadius="999px"
        bg={useColorModeValue("rgba(6,182,212,0.35)", "rgba(6,182,212,0.45)")}
        border="1px solid"
        borderColor={border}
      />
    </Box>
  );
}

function PersonCard({ person, isMobile, variant = "default" }) {
  const isPI = variant === "pi";

  const affiliation =
    typeof person.affiliation === "string"
      ? person.affiliation
      : isMobile
      ? person.affiliation?.mobile
      : person.affiliation?.desktop;

  const cardBg = useColorModeValue("white", "rgba(255,255,255,0.03)");
  const border = useColorModeValue("rgba(2,6,23,0.10)", "rgba(148,163,184,0.18)");
  const nameColor = useColorModeValue("#0F172A", "white");
  const affColor = useColorModeValue("gray.700", "gray.300");

  // ✅ size tuned for professional balance (and mobile)
  const sizePx = isPI ? (isMobile ? 210 : 250) : isMobile ? 180 : 220;

  return (
    <Box
      w="100%"
      maxW={isPI ? "560px" : { base: "520px", md: "300px", lg: "320px" }}
      bg={cardBg}
      border="1px solid"
      borderColor={border}
      borderRadius="26px"
      p={{ base: 6, md: 7 }}
      textAlign="center"
      boxShadow={useColorModeValue("0 14px 36px rgba(0,0,0,0.08)", "none")}
      transition="transform 160ms ease, box-shadow 160ms ease"
      _hover={{
        transform: "translateY(-2px)",
        boxShadow: useColorModeValue("0 18px 50px rgba(0,0,0,0.12)", "none"),
      }}
    >
      <AvatarCircle src={person.imageSrc} alt={person.alt ?? person.name} sizePx={sizePx} />

      <Text mt={5} fontWeight="900" color={nameColor} fontSize={{ base: "lg", md: isPI ? "xl" : "lg" }}>
        {person.name}
      </Text>

      {affiliation ? (
        <Text mt={2} fontSize={{ base: "sm", md: "md" }} color={affColor} fontWeight="600" lineHeight={1.6}>
          {affiliation}
        </Text>
      ) : null}
    </Box>
  );
}

function PartnerLogo({ partner, isMobile }) {
  const border = useColorModeValue("rgba(2,6,23,0.10)", "rgba(148,163,184,0.18)");
  const bg = useColorModeValue("rgba(255,255,255,0.92)", "rgba(255,255,255,0.05)");
  const shadow = useColorModeValue("0 10px 26px rgba(0,0,0,0.08)", "none");

  return (
    <Box
      bg={bg}
      border="1px solid"
      borderColor={border}
      borderRadius="18px"
      p={{ base: 4, md: 5 }}
      boxShadow={shadow}
      display="flex"
      alignItems="center"
      justifyContent="center"
      minH={{ base: "92px", md: "110px" }}
    >
      <Image
        src={partner.imageSrc}
        alt={partner.alt ?? partner.name}
        w="100%"
        maxW={isMobile ? "140px" : "200px"}
        h="auto"
        objectFit="contain" // ✅ no cropping
        draggable={false}
      />
    </Box>
  );
}
